import { getPreLoginPath, savePreLoginPath, markOAuthRedirectPending } from "@/storage/authentication";
import { GenericUtils } from "@/utils/GenericUtils";
import { TAuthConfig, TRefreshTokenExpiredEvent } from "react-oauth2-code-pkce";

const authenticationBaseUrl = import.meta.env.VITE_IBABS_AUTH_BASE_URL;
const pathname = window.location.pathname;

// Config functions
function preLoginHandle() {
  markOAuthRedirectPending();
  savePreLoginPath(pathname);
}

function postLoginHandle() {
  const pathnameStorage = getPreLoginPath();
  if (pathnameStorage !== pathname) {
    window.location.replace(pathnameStorage);
  }
}

function onRefreshTokenExpireHandle(event: TRefreshTokenExpiredEvent) {
  const confirm = window.confirm("Tokens have expired. Refresh page to continue using the site?");
  if (confirm) event.logIn();
}

// development

const authenticationRedirectUrl = window.location.origin + "/";
const deviceKey = GenericUtils.getGetOrCreateKey(import.meta.env.VITE_IBABS_AUTH_DEVICE_KEY);

const authConfig: TAuthConfig = {
  clientId: import.meta.env.VITE_IBABS_AUTH_CLIENT_ID,
  authorizationEndpoint: `${authenticationBaseUrl}/OAuth/Authorize`,
  tokenEndpoint: `${authenticationBaseUrl}/OAuth/Token`,
  redirectUri: authenticationRedirectUrl,
  extraAuthParameters: { device_key: deviceKey },
  extraTokenParameters: { device_key: deviceKey },
  logoutEndpoint: `${authenticationBaseUrl}/Account/Logout`,
  onRefreshTokenExpire: onRefreshTokenExpireHandle,
  // Example to redirect back to original path after login has completed
  preLogin: preLoginHandle,
  postLogin: postLoginHandle,
  storage: "session",
  decodeToken: true,
  autoLogin: false,
  refreshWithAuthHeader: true,
  refreshWithScope: false,
  refreshTokenExpiryStrategy: "renewable",
  tokenExpiresIn: import.meta.env.VITE_TOKEN_EXPIRES_IN,
  refreshTokenExpiresIn: import.meta.env.VITE_REFRESH_TOKEN_EXPIRES_IN,
};

export default {
  authenticationConfig: authConfig,
  authenticationDeviceKey: deviceKey,
};
